import { ref, withParams } from 'vuelidate/lib/validators/common';
import { helpers } from 'vuelidate/lib/validators';

export default isWholeNumber => withParams(
  { type: 'isWholeNumber', eq: isWholeNumber },
  (value, parentVm) => {
    if (!helpers.req(value) || (Number.isInteger(value * 1) && !value.includes('.'))) {
      return true;
    }

    return false;
  },
);
